module.exports = __webpack_public_path__ + "img/lead_slide6.75474ee3.png";